module.exports = __webpack_public_path__ + "static/media/logo-icon.ebfb2f5e.svg";